import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productBoxOne'
})
export class ProductBoxOnePipe implements PipeTransform {

  transform(value: String, arg1:String): String {
    if(value.toUpperCase() === 'ITR'){
      return "ITR"
    }
    else{
      return value.replace(/\sItr/g," ITR");
    }
    
  }

}
